<template>
  <div class="game-container">
    <div id="game-container"><canvas id="gameCanvas"></canvas></div>
  </div>
</template>

<script>
import _ from 'lodash';
import createjs from 'createjs-collection';
import preload from 'preload-js';
export default {
  name: 'mp-sortable-multi-v2',
  components: {},
  props: {
    startGameConfig: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      initData: {},
      stage: null,
      width: 0,
      height: 0,
      offset: {},
      images: [],
      // indx: [],
      containers: [],
      moved: false,
      ticker: false,
      movesTo: [],
    };
  },
  beforeMount() {},
  mounted() {
    this.stage = new createjs.Stage('gameCanvas');
    this.stage.mouseMoveOutside = true;
    this.stage.snapToPixelEnabled = true;
    this.ticker = createjs.Ticker;
    this.ticker.framerate = 60;
    if (this.ticker.hasEventListener('tick')) this.ticker.removeAllEventListeners();
    this.ticker.addEventListener('tick', this.tick);
    this.initGame();
    createjs.Touch.enable(this.stage);
    // console.log(createjs.Touch.isSupported());
  },
  created() {},
  methods: {
    setStage() {
      this.initData = _.cloneDeep(this.startGameConfig);
      this.width = this.initData.width ? this.initData.width : document.getElementById('game-container').offsetWidth;
      this.height = this.initData.height
        ? this.initData.height
        : document.getElementById('game-container').offsetHeight;
      this.stage.canvas.width = this.width;
      this.stage.canvas.height = this.height;
      this.offset = {
        x: this.stage.canvas.width / 2,
        y: this.stage.canvas.height / 2,
      };
      // console.log(this.width);
      this.stage.x = this.offset.x;
      this.stage.y = this.offset.y;
    },
    initGame() {
      this.resetCheckStatus();
      this.setStage();
      for (let i = 0; i < this.initData.targets.length; i++) {
        let container = new createjs.Container();
        container.name = this.initData.targets[i].id;
        if (this.initData.targets[i].bgr.split('/').length == 1) {
          let shape = new createjs.Shape();
          shape.width = this.initData.targets[i].pos.w ? this.initData.targets[i].pos.w : this.width;
          shape.height = this.initData.targets[i].pos.h ? this.initData.targets[i].pos.h : this.height;
          shape.graphics.f(this.initData.targets[i].bgr).dr(0, 0, shape.width, shape.height).ef();
          shape.id = this.initData.targets[i].id;
          container.x =
            (this.initData.targets[i].pos.x ? this.initData.targets[i].pos.x : (this.width - shape.width) / 2) -
            this.offset.x;
          container.y =
            (this.initData.targets[i].pos.y ? this.initData.targets[i].pos.y : (this.height - shape.height) / 2) -
            this.offset.y;
          container.width = shape.width;
          container.height = shape.height;
          container.addChild(shape);
        } else {
          let queue = new preload.LoadQueue();
          var self = this;
          container.x = (this.initData.targets[i].pos.x ? this.initData.targets[i].pos.x : 0) - this.offset.x;
          container.y = (this.initData.targets[i].pos.y ? this.initData.targets[i].pos.y : 0) - this.offset.y;
          queue.on('fileload', function (e) {
            let bmp = new createjs.Bitmap(e.result.src);
            bmp.id = e.item.id;
            e.item.cont.addChild(bmp);
            e.item.cont.width = e.result.width;
            e.item.cont.height = e.result.height;
          });
          queue.on('complete', function (e) {
            self.stage.update();
          });
          queue.loadManifest([{ cont: container, id: this.initData.targets[i].id, src: this.initData.targets[i].bgr }]);
        }
        this.stage.addChildAt(container, 0);
        this.containers[container.name] = {
          id: container.name,
          cont: container,
          correct: this.initData.targets[i].correct ? this.initData.targets[i].correct : [],
          indx: [],
        };
      }
      let container = new createjs.Container();
      container.name = 'source';
      if (this.initData.source.bgr.split('/').length == 1) {
        let shape = new createjs.Shape();
        shape.width = this.initData.source.pos.w ? this.initData.source.pos.w : this.width;
        shape.height = this.initData.source.pos.h ? this.initData.source.pos.h : this.height;
        shape.graphics.f(this.initData.source.bgr).dr(0, 0, shape.width, shape.height).ef();
        shape.id = 'source';
        container.x =
          (this.initData.source.pos.x ? this.initData.source.pos.x : (this.width - shape.width) / 2) - this.offset.x;
        container.y =
          (this.initData.source.pos.y ? this.initData.source.pos.y : (this.height - shape.height) / 2) - this.offset.y;
        container.addChild(shape);
        this.stage.addChild(container);
      } else {
        let queue = new preload.LoadQueue();
        var self = this;
        container.x = (this.initData.source.pos.x ? this.initData.source.pos.x : 0) - this.offset.x;
        container.y = (this.initData.source.pos.y ? this.initData.source.pos.y : 0) - this.offset.y;
        queue.on('fileload', function (e) {
          let bmp = new createjs.Bitmap(e.result.src);
          bmp.id = e.item.id;
          e.item.cont.addChild(bmp);
        });
        queue.on('complete', function (e) {
          self.stage.update();
        });
        queue.loadManifest([{ cont: container, id: this.initData.source.id, src: this.initData.source.bgr }]);
      }
      this.stage.addChildAt(container, 0);
      this.containers[container.name] = {
        id: container.name,
        cont: container,
        correct: this.initData.source.correct ? this.initData.source.correct : [],
        indx: [],
      };
      this.loadImages();

      this.stage.update();
    },
    loadImages() {
      var self = this;
      let pick = this.initData.pick
        ? this.initData.pick > this.initData.samples.length
          ? this.initData.samples.length
          : this.initData.pick
        : this.initData.samples.length;
      var indx = [];

      do {
        indx = [];
        for (let i = 0; i < pick; i++) {
          let ix = Math.round(Math.random() * (this.initData.samples.length - 1));
          let flg = false;
          for (let j = 0; j < indx.length; j++) if (indx[j] == ix) flg = true;
          if (flg) i--;
          else indx[i] = ix;
        }
        var ok = 0;
        if (this.initData.corrBlock) {
          var tab = [];
          for (let i = 0; i < this.initData.targets.length; i++) {
            tab = tab.concat(this.initData.targets[i].correct);
          }

          for (let i = 0; i < indx.length; i++) {
            if (tab[i] == this.initData.samples[indx[i]].id) ok++;
          }
        }
      } while (ok == indx.length);

      var images = [];

      indx.forEach(function (ind, i) {
        images[i] = Object.assign({}, self.initData.samples[ind]);
      });

      var manifest = [];

      images.forEach(function (img) {
        manifest.push(img);
      });

      let queue = new preload.LoadQueue();
      queue.on('fileload', function (e) {
        self.handleFileLoad(e);
      });
      queue.on('complete', function (e) {
        let container = self.stage.getChildByName('source');
        self.images.forEach(function (bmp) {
          if (!bmp.parent) container.addChildAt(bmp, 1);
        });
        self.stage.update();
      });
      queue.loadManifest(manifest);
    },
    shuffle(a) {
      if (a.length == 0) return;
      for (let i = a.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [a[i], a[j]] = [a[j], a[i]];
      }
      return a;
    },
    newGame() {
      this.mousedown = false;
      this.stage.removeAllChildren();
      this.stage.removeAllEventListeners();
      this.containers.splice(0, this.containers.length);
      this.movesTo.splice(0, this.movesTo.length);
      this.images.splice(0, this.images.length);

      this.initGame();
      this.stage.update();
    },
    handleFileLoad(e) {
      var image = e.result;
      let bmp = new createjs.Bitmap(image.src);
      let container = this.stage.getChildByName('source');

      bmp.id = e.item.id;
      bmp.block = false;

      bmp.ix = this.containers['source'].indx.length;
      bmp.move = false;

      var i = container.children.length - 1;
      var self = this;
      if (this.initData.isHor) {
        bmp.x =
          (this.initData.source.margin && this.initData.source.margin.left ? this.initData.source.margin.left : 0) +
          (image.width +
            (this.initData.source.margin && this.initData.source.margin.lineH
              ? this.initData.source.margin.lineH
              : 15)) *
            i;
        bmp.y = this.initData.source.margin && this.initData.source.margin.top ? this.initData.source.margin.top : 0;
        this.initData.targets.forEach(function (cont) {
          let ch = Math.floor((cont.pos.w ? cont.pos.w : self.containers[cont.id].cont.width) / image.width);
          let mod = i % ch;
          let x =
            (cont.margin && cont.margin.left ? cont.margin.left : 0) +
            (image.width + (cont.margin && cont.margin.lineH ? cont.margin.lineH : 15)) * mod;
          let y =
            (cont.margin && cont.margin.top ? cont.margin.top : 0) +
            (image.height + (cont.margin && cont.margin.lineH ? cont.margin.lineH : 15)) * Math.floor(i / ch);
          self.containers[cont.id].indx.push({ x: x, y: y });
        });
        if (this.initData.source.isVer) {
          bmp.x =
            this.initData.source.margin && this.initData.source.margin.left ? this.initData.source.margin.left : 0;
          bmp.y =
            (this.initData.source.margin && this.initData.source.margin.top ? this.initData.source.margin.top : 0) +
            (image.height +
              (this.initData.source.margin && this.initData.source.margin.lineH
                ? this.initData.source.margin.lineH
                : 15)) *
              i;
        }
      } else {
        bmp.x = this.initData.source.margin && this.initData.source.margin.left ? this.initData.source.margin.left : 0;
        bmp.y =
          (this.initData.source.margin && this.initData.source.margin.top ? this.initData.source.margin.top : 0) +
          (image.height +
            (this.initData.source.margin && this.initData.source.margin.lineH
              ? this.initData.source.margin.lineH
              : 15)) *
            i;

        this.initData.targets.forEach(function (cont) {
          let ch = Math.floor((cont.pos.h ? cont.pos.h : self.containers[cont.id].cont.height) / image.height);
          let mod = i % ch;
          let x =
            (cont.margin && cont.margin.left ? cont.margin.left : 0) +
            (image.width + (cont.margin && cont.margin.lineH ? cont.margin.lineH : 15)) * Math.floor(i / ch);
          let y =
            (cont.margin && cont.margin.top ? cont.margin.top : 0) +
            (image.height + (cont.margin && cont.margin.lineH ? cont.margin.lineH : 15)) * mod;

          self.containers[cont.id].indx.push({ x: x, y: y });
        });
        if (this.initData.source.isHor) {
          bmp.x =
            (this.initData.source.margin && this.initData.source.margin.left ? this.initData.source.margin.left : 0) +
            (image.width +
              (this.initData.source.margin && this.initData.source.margin.lineH
                ? this.initData.source.margin.lineH
                : 15)) *
              i;
          bmp.y = this.initData.source.margin && this.initData.source.margin.top ? this.initData.source.margin.top : 0;
        }
      }

      bmp.pos = { x: bmp.x, y: bmp.y };
      bmp.newPos = { x: bmp.x, y: bmp.y };
      this.containers['source'].indx.push({ x: bmp.x, y: bmp.y });

      bmp.on('mousedown', this.stageMouseDown);
      bmp.on('pressup', this.stageMouseUp);

      this.images.push(bmp);
      container.addChild(bmp);
    },
    findContainer(e) {
      var cont = false,
        self = this;
      var items = this.stage.getObjectsUnderPoint(e.stageX - this.offset.x, e.stageY - this.offset.y);
      items.forEach(function (obj) {
        if (self.containers[obj.id]) {
          cont = self.containers[obj.id];
        }
      });
      return cont ? cont : this.containers['source'];
    },
    stageMouseDown(e) {
      this.resetCheckStatus();
      var ix = -1,
        cont = this.findContainer(e);

      if (cont) {
        this.images.forEach(function (bmp, i) {
          if (e.target.id == bmp.id) {
            ix = i;
          }
        });
      }

      if (ix >= 0 && cont && !this.images[ix].block) {
        let x = this.images[ix].parent.x;
        let y = this.images[ix].parent.y;
        let parent = this.images[ix].parent.name;
        this.stage.addChildAt(this.images[ix], this.stage.children.length);
        this.stage.update();
        this.stage.on('stagemousemove', this.stageMouseMove);
        this.moved = this.images[ix];
        this.moved.x += x;
        this.moved.y += y;
        this.moved.stageX = e.stageX - this.offset.x;
        this.moved.stageY = e.stageY - this.offset.y;
        this.moved.oldParent = parent;
        this.moved.outParent = parent;
        this.moved.newParent = null;
        this.mousedown = true;
      } else this.moved = null;
      this.stage.update();
    },
    stageMouseMove(e) {
      if (this.mousedown) {
        this.moved.x += e.stageX - this.moved.stageX - this.offset.x;
        this.moved.y += e.stageY - this.moved.stageY - this.offset.y;
        this.moved.stageX = e.stageX - this.offset.x;
        this.moved.stageY = e.stageY - this.offset.y;

        this.moved.x = Math.round(this.moved.x);
        this.moved.y = Math.round(this.moved.y);
        if (this.movesTo.length == 0) {
          var items = this.stage.getObjectsUnderPoint(e.stageX - this.offset.x, e.stageY - this.offset.y);

          var self = this;
          var cont = this.findContainer(e);

          if (cont.id != 'source') {
            if (cont.cont.name != this.moved.oldParent && cont.cont.name != this.moved.newParent) {
              this.moved.ix = cont.cont.children.length - 1;
              this.moved.newParent = cont.cont.name;
            }
            if (items.length > 2) {
              items.forEach(function (item) {
                if (item.block === false && item.id != self.moved.id && !item.move && item.ix !== undefined) {
                  let x1 = self.moved.ix;
                  let x2 = item.ix;

                  self.moved.ix = x2;
                  item.ix = x1;
                  item.newPos = { x: cont.indx[item.ix].x, y: cont.indx[item.ix].y };
                  item.move = true;
                  self.movesTo.push(item);
                }
              });
            }
          }

          if (cont.cont.name != this.moved.outParent && this.moved.outParent != 'source') {
            let c = this.containers[this.moved.outParent].cont.children.length;
            if (c >= 1) {
              this.sortChildren(this.containers[this.moved.outParent]);
            }
            this.moved.outParent = cont.cont.name;
          }
        }
        this.stage.update();
      }
    },
    sortChildren(cont) {
      var sort = false;
      var tab = [];
      for (let i = 0; i <= cont.cont.children.length; i++) {
        let child = cont.cont.children[i];
        if (child && child.ix !== undefined) {
          tab.push(child.ix);
        }
      }
      tab.sort();

      for (let i = 0; i < tab.length; i++) {
        let c = tab[i] - i;
        if (Math.abs(c) >= 1) {
          for (let j = 0; j < cont.cont.children.length; j++) {
            let child = cont.cont.children[j];
            if (child.ix === tab[i]) {
              child.ix = i;
              child.newPos = { x: cont.indx[child.ix].x, y: cont.indx[child.ix].y };
              child.move = true;
              this.movesTo.push(child);
              sort = true;
              break;
            }
          }
        }
      }

      return sort;
    },
    stageMouseUp(e) {
      if (this.mousedown) {
        this.mousedown = false;
        var cont = this.findContainer(e);

        this.moved.newParent = null;
        this.moved.parent.removeChild(this.moved);
        cont.cont.addChild(this.moved);
        this.moved.x = Math.abs(Math.abs(cont.cont.x) - Math.abs(Math.round(e.stageX - this.offset.x)));
        this.moved.y = Math.abs(Math.abs(cont.cont.y) - Math.abs(Math.round(e.stageY - this.offset.y)));

        this.moved.newPos = { x: this.moved.pos.x, y: this.moved.pos.y };
        if (cont && cont.id != 'source') {
          this.sortChildren(cont);
          if (this.moved.outParent != 'source') this.sortChildren(this.containers[this.moved.outParent]);

          this.moved.newPos = { x: cont.indx[this.moved.ix].x, y: cont.indx[this.moved.ix].y };
          this.moved.move = true;
        }

        this.moved.outParent = null;

        this.movesTo.push(this.moved);
        this.stage.update();
        this.stage.removeAllEventListeners('stagemousemove');
      }
    },

    anim(bmp) {
      let count = 20;

      if (Math.abs(bmp.x - bmp.newPos.x) < count) bmp.x = bmp.newPos.x;

      if (bmp.x < bmp.newPos.x) bmp.x += count;
      else if (bmp.x > bmp.newPos.x) bmp.x -= count;

      if (Math.abs(bmp.y - bmp.newPos.y) < count) bmp.y = bmp.newPos.y;

      if (bmp.y < bmp.newPos.y) bmp.y += count;
      else if (bmp.y > bmp.newPos.y) bmp.y -= count;
    },
    tick(e) {
      if (this.movesTo.length > 0) {
        for (let i = 0; i < this.movesTo.length; i++) {
          this.anim(this.movesTo[i]);
          if (this.movesTo[i].x == this.movesTo[i].newPos.x && this.movesTo[i].y == this.movesTo[i].newPos.y) {
            this.movesTo[i].move = false;
            this.movesTo.splice(i, 1);
          }
        }
        this.stage.update();
      }
    },
    resetGameAction() {
      this.newGame();
    },
    checkGameAction() {
      var isCorrect = true;
      var self = this;

      Object.keys(this.containers).forEach(function (key) {
        var cont = self.containers[key];
        if (cont.correct.length != cont.cont.children.length - 1) isCorrect = false;
        else if (cont.correct.length > 0 && cont.id != 'source') {
          var solv = [];
          for (let i = 0; i < cont.indx.length; i++) {
            for (let j = 0; j < cont.cont.children.length; j++) {
              if (cont.cont.children[j].ix == i) {
                solv.push({ id: cont.cont.children[j].id, ix: j });
                break;
              }
            }
          }

          for (let i = 0; i < solv.length; i++) {
            if (solv[i].id != cont.correct[i]) isCorrect = false;
            else if (self.initData.corrBlock !== false) {
              cont.cont.children[solv[i].ix].block = true;
            }
          }
        }
      });

      if (isCorrect) {
        this.images.forEach(function (bmp) {
          bmp.block = true;
        });
      }

      return isCorrect;
    },
    resetCheckStatus() {
      this.$store.dispatch('resetCheckStatus');
      return true;
    },
  },
  beforeDestroy() {
    this.stage.removeAllEventListeners();
    this.ticker.removeAllEventListeners();
  },
  computed: {
    checkGame() {
      return this.$store.getters.checkGame;
    },
    resetGameSwitch() {
      return this.$store.getters.resetGame;
    },
  },
  watch: {
    checkGame: function (newStatus, oldStatus) {
      if (newStatus) {
        this.$store.dispatch('checkGame', this.checkGameAction());
        this.$store.commit('CHECK_GAME', false);
      }
    },
    resetGameSwitch(newStatus, oldStatus) {
      if (newStatus) {
        this.resetGameAction();
        this.$store.dispatch('resetGame');
      }
    },
  },
};
</script>
<style lang="scss"></style>
<style lang="scss" scoped>
.game-container {
  display: flex;
  padding: 160px 50px 100px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}

#game-container {
  margin: 0;
  width: 100%;
  height: 100%;
}

canvas {
  border: 1px solid brown;
}
</style>
